import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFeatureAccessContext } from '../../../context/featureAccess'
import { useMindmapData } from './useMindmapData'

export function useReportData(mindmapId: string | undefined) {
  const navigate = useNavigate()
  const { loading, mindmap, projectLabels, nodeLabelMap } = useMindmapData(mindmapId)

  // Feature access check for PDF export
  const { checkFeature } = useFeatureAccessContext()
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const [hasAccess, setHasAccess] = useState<boolean | null>(null)

  // Check PDF export feature access on mount
  useEffect(() => {
    const { hasAccess: access } = checkFeature('pdf_export')
    setHasAccess(access)
    if (!access) {
      setShowUpgradeModal(true)
    }
  }, [checkFeature])

  const handleUpgradeModalClose = () => {
    setShowUpgradeModal(false)
    if (mindmapId) {
      void navigate(`/mindmap/${mindmapId}`)
    } else {
      void navigate('/')
    }
  }

  return {
    loading,
    mindmap,
    projectLabels,
    nodeLabelMap,
    hasAccess,
    showUpgradeModal,
    handleUpgradeModalClose,
  }
}
